import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useGetUserSpeakingLevelByEmail } from "./useGetUserSpeakingLevelByEmail.ts";
import { OneOnOneTypeformThankYouScreenPath } from "./OneOnOneTypeformThankYouScreen.tsx";

export const OneOnOneTypeformRedirectScreenPath =
  "/one-on-one-typeform-redirect";

const SELF_ASSESSMENT_TYPEFORM_URL = import.meta.env.VITE_SELF_ASSESSMENT_URL;

export function OneOnOneTypeformRedirectScreen() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const result = useGetUserSpeakingLevelByEmail(email);
  const navigate = useNavigate();

  useEffect(() => {
    if (result.status !== "found") return;

    if (!result.hasSpeakingLevel) {
      const destination = new URL(SELF_ASSESSMENT_TYPEFORM_URL);
      searchParams.forEach((value, key) => {
        destination.searchParams.set(key, value);
      });
      window.location.replace(destination.toString());
    } else {
      navigate(OneOnOneTypeformThankYouScreenPath, { replace: true });
    }
  }, [result, searchParams, navigate]);

  if (result.status === "loading") {
    return null;
  }

  if (result.status === "not_found") {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-gray-600">User not found</p>
      </div>
    );
  }

  return null;
}
